export default __webpack_public_path__ + "static/media/Q04_清澈提琴聲，輕巧的旋律蔓延整座天際.15a7cedb.mp4";